import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { NbIconConfig } from '@nebular/theme';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { AveriasService } from '../servicios/averias.service';
import { SelectItem } from 'primeng/api';
import { GrupoTipo } from '../entidades/entidades.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent} from '../snack-bar/snack-bar.component';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { DatePipe } from '@angular/common';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { AnalyticsService } from '../servicios/analytics.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatHint } from '@angular/material/form-field';
import { NbTabsetModule } from '@nebular/theme';
import { NbCheckboxModule } from '@nebular/theme';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-grupo-tipo',
    templateUrl: './grupo-tipo.component.html',
    styleUrls: ['./grupo-tipo.component.css'],
    styles: [`
    :host nb-tab {
      padding: 1.25rem;
    }
  `],
  standalone: true,
  imports: [AngularSlickgridModule,FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,MatCardModule, 
    SpinnerComponent
  , MatFormFieldModule, MatInputModule, MatIconModule, MatHint,
  NbTabsetModule,NbCheckboxModule,
  AgGridAngular
],
providers: [DatePipe],
})
export class GrupoTipoComponent implements OnInit {
  durationInSeconds = 3;
  grupoTipo: SelectItem[];
  grupoSeleccionado: { name: string, code: number } = { name: '-', code: 0 };
  firstForm: UntypedFormGroup;
  averiasOK = false;
  IdGrupoTipo: number;
  showTipo = false;
  grupoTipoProcesado;
  checked = false;
  descripcionGrupoTipo;
  descripcionBreve;
  codigoExterno;
  clienteId;
  grupoTipoCompleto;
  descripcionBreveEditar;
  descripcionGrupoTipoEditar;
  codigoExternoEditar;
  loadingResponseGrupoTipo = false;
  datasetGrupoTipo: any[] = [];
  datasetGrupoTipoConsulta: any[] = [];
  datasetGrupoTipoGrillaModificar: any[] = [];
  angularGridGrupoTipo: AngularGridInstance;
  angularGridGrupoTipoConsulta: AngularGridInstance;
  angularGridGrupoTipoModificar: AngularGridInstance;
  dataViewGrupoTipo: any;
  showSpinner = false;
  //columnDefinitionsGrupoTipo: Column[];
  columnDefinitionsGrupoTipo: ColDef[];
  //columnDefinitionsGrupoTipoModificar: Column[];
  columnDefinitionsGrupoTipoModificar: ColDef[];
  gridOptionsGrupoTipo: GridOption;
  gridOptionsGrupoTipoModificar: GridOption;


  //columnDefinitionsGrupoTipoConsulta: Column[];
  columnDefinitionsGrupoTipoConsulta: ColDef[];
  gridOptionsGrupoTipoConsulta: GridOption;

  gridObjGrupoTipo: any;
  showGrilla = false;
  showSpinnerGuardar = false;
  showSpinnerModificar = false;
  showSpinnerGrillaModificar = false;
  showGrupoTipoModificar = false;
  idCliente:number;
  eliminar = false;
  eliminarSeleccionado;
  showSpinnerConsulta = false;
  showGrupoTipoConsulta = false;
  showGrillaConsulta = false;

  @ViewChild('grilla1') grilla1!: AgGridAngular;
  @ViewChild('grilla2') grilla2!: AgGridAngular;
  @ViewChild('grilla3') grilla3!: AgGridAngular;


  constructor(private fb: UntypedFormBuilder, private AveriasService: AveriasService, 
    private _snackBar: MatSnackBar, private dateFormatter:DatePipe, 
    public usersRol: PerfilesUsuarioService, private svcAnalytics: AnalyticsService) { }

  ngOnInit() {
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.firstForm = this.fb.group({
      firstCtrl: ['-', Validators.required],
    });
    this.svcAnalytics.setAnalyticsPageView();
  }

  ngAfterViewInit():void {
  }

  onChangeTab(event){
    if(event.tabTitle == "Alta"){
      this.consultarGrupoTipo();
    }
    if(event.tabTitle == "Consulta"){
      this.consultarGrupoTipoConsulta();
    }
    if(event.tabTitle == "Modificación"){
      this.consultarGrupoTipoModificar();
    }
  }

  bellIconConfig: NbIconConfig = { icon: 'bell-outline', pack: 'eva' };
  inputItemNgModel;
  textareaItemNgModel;
  inputItemFormControl = new UntypedFormControl();
  textareaItemFormControl = new UntypedFormControl();

  toggleEliminar(eliminar: boolean) {
    this.eliminar = eliminar;
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  consultarGrupoTipo() {
    this.showSpinner = true;
    this.showGrilla = false;
    this.AveriasService.getGrupoTipo(this.idCliente).subscribe(
      data => {
        this.grupoTipoCompleto = data;
        this.grupoTipo = this.insertarGrupoTipo(data);
        this.traerDatosGrupoTipo();
        this.fillGrillaGrupoTipo();
      });
  }
  consultarGrupoTipoConsulta() {
    this.showSpinnerConsulta = true;
    this.showGrupoTipoConsulta = false;
    this.AveriasService.getGrupoTipo(this.idCliente).subscribe(
      data => {
        this.grupoTipoCompleto = data;
        this.traerDatosGrupoTipoConsulta();
        this.fillGrillaGrupoTipoConsulta();
      });
  }
  consultarGrupoTipoModificar() {
    this.showSpinnerGrillaModificar = true;
    this.showGrupoTipoModificar = false;
    this.AveriasService.getGrupoTipo(this.idCliente).subscribe(
      data => {
        this.grupoTipoCompleto = data;
        this.grupoTipo = this.insertarGrupoTipo(data);
        this.traerDatosGrupoTipoModificar();
        this.fillGrillaGrupoTipoModificar();
      });
  }
  insertarGrupoTipo(armarGrupoTipo) {
    let averiasGrupoTipo: Array<any> = [];
    armarGrupoTipo.content.forEach(element => {
      averiasGrupoTipo.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasGrupoTipo;
  };
  capturarGrupoTipo(event) {
    this.IdGrupoTipo = event;
    this.averiasOK = true;
  }
  altaGrupoTipo() {
    let grupoTipo: GrupoTipo;

    if (this.descripcionGrupoTipo == null || this.descripcionGrupoTipo == "") {
      this.openSnackBar("Debe Completar la Descripción ❌");
    } else if (this.descripcionBreve == null || this.descripcionBreve == "") {
      this.openSnackBar("Debe Completar la Descripción Breve ❌");
    } else if (this.codigoExterno == null || this.codigoExterno == "") {
      this.openSnackBar("Debe Completar el Código Externo ❌");
    } else {
      grupoTipo = {
        descripcion: this.descripcionGrupoTipo,
        descripcionAbreviada: this.descripcionBreve,
        codigoExterno: this.codigoExterno,
        clienteId: this.idCliente
      }
      this.showSpinnerGuardar = true;
      this.AveriasService.postGrupoTipo(grupoTipo).subscribe(data => {
        if(data["status"] == 201){
          this.openSnackBar('Los cambios se han guardado correctamente');
          //gtag de alta
          this.svcAnalytics.setAnalyticsAltaButton();
           } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
        this.descripcionGrupoTipo = '';
        this.descripcionBreve = '';
        this.codigoExterno = '';
        this.consultarGrupoTipo();
        this.showSpinnerGuardar = false;
      })
    }
  }
  modificarGrupoTipo () {
    let grupoTipo: GrupoTipo ; 
    if (this.eliminar) {
      this.AveriasService.deleteGrupoTipoPorId(this.grupoTipoProcesado).subscribe(data => {
        if (data["status"] == 204) {
          this.openSnackBar('Los datos se han eliminado correctamente');
          this.descripcionGrupoTipoEditar = '';
          this.descripcionBreveEditar = '';
          this.codigoExternoEditar = '';
          this.grupoTipoProcesado = '';
          //gtag de Baja
          this.svcAnalytics.setAnalyticsBajaButton();
        } else {
          this.openSnackBar('Ha ocurrido un error al borrar los datos');
        }
        this.eliminar = false;
        this.eliminarSeleccionado = false;
        this.consultarGrupoTipoModificar();
      })
    } else {
      if (this.descripcionGrupoTipoEditar == null || this.descripcionGrupoTipoEditar == "") {
        this.openSnackBar("Debe Completar la Descripción ❌");
      } else if (this.descripcionBreveEditar == null || this.descripcionBreveEditar == "") {
        this.openSnackBar("Debe Completar la Descripción Breve ❌");
      } else if (this.codigoExternoEditar == null || this.codigoExternoEditar == "") {
        this.openSnackBar("Debe Completar el Código Externo ❌");
      } else {
        this.showSpinnerModificar = true;
        grupoTipo = {
          descripcion: this.descripcionGrupoTipoEditar,
          descripcionAbreviada: this.descripcionBreveEditar,
          codigoExterno: this.codigoExternoEditar,
          clienteId: this.idCliente,
      }
      this.AveriasService.putGrupoTipo(this.grupoTipoProcesado, grupoTipo).subscribe(data =>{
        if(data["status"] == 200){
          this.openSnackBar('Los cambios se han guardado correctamente');
          //gtag de modificacion
          this.svcAnalytics.setAnalyticsModificacionButton();
           } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
        this.showSpinnerModificar = false;
        this.eliminar = false;
        this.eliminarSeleccionado = false;
        this.consultarGrupoTipoModificar();
      })
      this.descripcionGrupoTipoEditar = '';
      this.descripcionBreveEditar = '';
      this.codigoExternoEditar = '';
      this.grupoTipoProcesado = '';
      this.eliminarSeleccionado = false;
      
    }
    }
  }
  obtenerDescripcionDropdown(IdGrupoTipo: number) {
    let resp = this.grupoTipoCompleto.content.find(n => n['id'] == IdGrupoTipo);
    this.descripcionBreveEditar = resp['descripcionAbreviada'];
    this.descripcionGrupoTipoEditar = resp['descripcion'];
    this.codigoExternoEditar = resp['codigoExterno'];
    this.eliminarSeleccionado = false;
  }
  //Grilla GrupoTipo
  traerDatosGrupoTipo() {
    let DatosGrupoTipo = this.grupoTipoCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosGrupoTipo.length; i++) {
      mockDataset.push({
        id: DatosGrupoTipo[i]["id"],
        Descripcion: DatosGrupoTipo[i]["descripcion"],
        DescripcionAbreviada: DatosGrupoTipo[i]["descripcionAbreviada"],
        codigoExterno: DatosGrupoTipo[i]["codigoExterno"],
      });
    }
    this.datasetGrupoTipo  = mockDataset;
    this.showSpinner = false;
    this.showGrilla = true;
  }

  traerDatosGrupoTipoConsulta() {
    let DatosGrupoTipo = this.grupoTipoCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosGrupoTipo.length; i++) {
      mockDataset.push({
        id: DatosGrupoTipo[i]["id"],
        Descripcion: DatosGrupoTipo[i]["descripcion"],
        DescripcionAbreviada: DatosGrupoTipo[i]["descripcionAbreviada"],
        codigoExterno: DatosGrupoTipo[i]["codigoExterno"],
      });
    }
    this.datasetGrupoTipoConsulta  = mockDataset;
    this.showSpinnerConsulta = false;
    this.showGrupoTipoConsulta = true;
  }

  traerDatosGrupoTipoModificar() {
    let DatosGrupoTipo = this.grupoTipoCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosGrupoTipo.length; i++) {
      mockDataset.push({
        id: DatosGrupoTipo[i]["id"],
        Descripcion: DatosGrupoTipo[i]["descripcion"],
        DescripcionAbreviada: DatosGrupoTipo[i]["descripcionAbreviada"],
        codigoExterno: DatosGrupoTipo[i]["codigoExterno"],
      });
    }
    this.datasetGrupoTipoGrillaModificar  = mockDataset;
    this.showSpinnerGrillaModificar = false;
    this.showGrupoTipoModificar = true;
  }
/* sortable: true, filter: true, floatingFilter: true, */
  fillGrillaGrupoTipo() {
    this.columnDefinitionsGrupoTipo = [
      { 
            //  {
            //   //id: 'modelo',
            //   headerName: 'Modelo',
            //   field: 'modelo',
            //   sortable: true,
            //   filter: true, floatingFilter: true,
            //   minWidth: 100,
            // },

        //id: 'Descripcion', 
        headerName: 'Descripción',
         field: 'Descripcion', 
         sortable: true, 
         filter: true, 
         floatingFilter: true,
         minWidth: 120, width: 120},

      { //id: 'DescripcionAbreviada',
         headerName: 'Descripción Abreviada', 
         field: 'DescripcionAbreviada', 
         sortable: true, 
         filter: true, 
         floatingFilter: true, 
         minWidth: 120, width: 120},
      { //id: 'codigoExterno',
         headerName: 'Código', 
         field: 'codigoExterno', 
         sortable: true, 
         filter: true, 
         floatingFilter: true, 
         minWidth: 80, 
         width: 80
      },
    ];
    this.gridOptionsGrupoTipo = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }
  fillGrillaGrupoTipoConsulta() {
    this.columnDefinitionsGrupoTipoConsulta = [
      {// id: 'Descripcion',
        headerName: 'Descripción', 
        field: 'Descripcion', 
        sortable: true, 
        filter: true, 
        floatingFilter: true, 
        minWidth: 210, width: 210
      },
      { //id: 'DescripcionAbreviada', 
        headerName: 'Descripción Abreviada', 
        field: 'DescripcionAbreviada', 
        sortable: true, 
        filter: true, 
        floatingFilter: true, 
        minWidth: 210, 
        width: 210},
      { 
        //id: 'codigoExterno', 
        headerName: 'Código', 
        field: 'codigoExterno', 
        sortable: true, 
        filter: true, floatingFilter: true, 
        minWidth: 120, 
        width: 120,
        resizable: true},
    ];
    this.gridOptionsGrupoTipoConsulta = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  fillGrillaGrupoTipoModificar() {
    this.columnDefinitionsGrupoTipoModificar = [
      { //id: 'Descripcion',
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 210, width: 210},
      { //id: 'DescripcionAbreviada',
        headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 210, width: 210},
      { //id: 'codigoExterno',
        headerName: 'Código', field: 'codigoExterno', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120},
    ];
    this.gridOptionsGrupoTipoModificar = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  angularGridReadyGrupoTipo(angularGrid: AngularGridInstance) {
    this.angularGridGrupoTipo = angularGrid;
    this.angularGridGrupoTipo.resizerService.pauseResizer(false)
  }
  angularGridReadyGrupoTipoConsulta(angularGrid: AngularGridInstance) {
    this.angularGridGrupoTipoConsulta = angularGrid;
    this.angularGridGrupoTipoConsulta.resizerService.pauseResizer(false)
  }
  angularGridReadyGrupoTipoModificar(angularGrid: AngularGridInstance) {
    this.angularGridGrupoTipoModificar = angularGrid;
    this.angularGridGrupoTipoModificar.resizerService.pauseResizer(false)
  }

  exportToExcelGrupoTipo() {
    // (this.angularGridGrupoTipoConsulta as any).excelExportService.exportToExcel({
    //   filename: 'Grupo Tipo_' + this.dateFormatter.transform(new Date(), "dd-MM-yyyy"),
    //   format: FileType.xlsx
    // });
    this.exportToExcelConXLSX();
    //gtag de reporte excel
    this.svcAnalytics.setAnalyticsExcelButton();
  }


   exportToExcelConXLSX(): void {
        const rowData: any[] = [];
       const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();
      
        // Obtener solo las filas visibles (después de filtros y orden)
        this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
          if (node.data) {
            const filaFiltrada: any = {};
      
            // Solo columnas visibles
            columnasVisibles.forEach(col => {
              const campo = col.getColDef().field;
              if (campo && campo!='action') {
                filaFiltrada[campo] = node.data[campo];
              }
            });
            rowData.push(filaFiltrada);
          }
        });
      
        if (rowData.length === 0) {
          console.warn('No hay datos para exportar');
          return;
        }
      
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
        const workbook: XLSX.WorkBook = {
          Sheets: { 'GrupoTipo': worksheet },
          SheetNames: ['GrupoTipo']
        };
      
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
      
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, 'Grupo Tipo_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
      }
      


    onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
    this.grilla2.api.sizeColumnsToFit();
    this.grilla3.api.sizeColumnsToFit();
    // this.grilla3.api.refreshHeader();
    // this.grilla3.api.redrawRows();

  }
}
